import { render, staticRenderFns } from "./CompareOddsIcon.vue?vue&type=template&id=3a402f13"
import script from "./CompareOddsIcon.vue?vue&type=script&lang=js"
export * from "./CompareOddsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports